import ScheduleColumnManager from '../../schedules/ScheduleColumnManager';

export default class FlexHoursColumnManager extends ScheduleColumnManager {
  constructor(session, counterparty) {
    super(session, counterparty);

    this.settings.grouping = {
      contractCode: {
        groupIndex: 0,
        sortOrder: 'asc'
      }
    };
  }

  addIntermediateColumns(columns) {
    super.addIntermediateColumns(columns);

    this.addColumn(columns, {
      alignment: 'left',
      allowEditing: false,
      allowFiltering: false,
      allowHiding: true,
      allowResizing: true,
      dataType: 'string',
      caption: 'Contract',
      dataField: 'contractCode',
      visible: true,
      width: 80
    });
  }

  addTrailingColumns(columns) {
    super.addTrailingColumns(columns);

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Flex Taken (Hours)',
      dataField: 'flexTakenH',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 80
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Flex Taken (MWh)',
      dataField: 'flexTakenMWh',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: true,
      width: 80
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Total (Hours)',
      dataField: 'totalH',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 95
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Total (MWh)',
      dataField: 'totalMWh',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 95
    });
  }

  getColumnCssClass() {
    return 'pwx-alert-overlay-none pwx-flag-none pwx-select-none pwx-state-normal pwx-highlight-none pwx-cell-standard';
  }
}